import { h } from "preact";

import Icon from "./Icon.jsx";
import { Link } from "react-router-dom";
import { classNames } from "../helpers.js";

export default function Breadcrumbs({ items, ...props }) {
  return (
    <div class={classNames("breadcrumbs", props.class)}>
      {items.map((item, index) => (
        <span
          class={classNames(
            "breadcrumbs__item",
            typeof item == "string" && "breadcrumbs__item--current"
          )}
        >
          {index > 0 && <Icon class="breadcrumbs__icon">chevron_right</Icon>}
          {typeof item == "string" ? (
            item
          ) : (
            <Link to={item.to} className="link--invisible">
              {item.title}
            </Link>
          )}
        </span>
      ))}
    </div>
  );
}
